import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

import CartClass from './../../../../../../../js/classes/Cart'

import GiftItem from './GiftItem.jsx'

const Gifts = ({ refetch, gifts, setLoading, setGifts }) => {
    const handleAddGift = (gift) => {
        setLoading(true)

        CartClass.add(gift.ID, 1, (err, res) => {
            if (err) {
                setLoading(false)
            } else {                
                refetch()
            }
        })
    }

    if (gifts.length > 0) {
        return <div className="happy-cart__gifts">
            { gifts.map((gift) => {
                return <GiftItem
                    key={ `gift-${ gift.ID }` }
                    gift={ gift }
                    handleAddGift={ handleAddGift }
                />
            }) }
        </div>
    } else {
        return null
    }
}

export default Gifts